/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export enum V1RequestStateStringEnum {
  'requestStateIdleString' = 'idle',
  'requestStateCheckinString' = 'checkin',
  'requestStateAcceptString' = 'accept',
  'requestStateDeclineString' = 'decline',
  'requestStateUnknownString' = 'unknown',
}

export type V1RequestStateString = V1RequestStateStringEnum